'use client';

import { useVersionCheck } from '@/hooks/useVersionCheck';

/** Static Pages routes need the same online/focus diagnostics as the workspace. */
export function ClientVersionProbe() {
  useVersionCheck();
  return null;
}
